export const DESTINATION_TYPE = {
  Rtmp: "rtmp"
} as const;
